import { useEffect }    from 'react';
import { connect }      from 'react-redux';
import {useParams}      from 'react-router-dom';

// Redux
import {getPartners}    from '../../redux/actions/Partners';
// Components
import Head         from '../global/Head';
import Tables       from './Tables';
import Form         from './Form';
// Values
import {StateView}  from '../../values';
// Api
import {getData}    from '../../utils/partners';

const Index = ({stateView, token, getPartners}) => {
    let { id }  = useParams();
    const GetData = async() =>{
        if(id){
            const res = await getData(token, `/${id}`)
            getPartners(res.data)
        } else{
            const res = await getData(token)
            getPartners(res.data)
        }
    }
    useEffect(() =>{
        if(token){
            if(stateView === StateView.state1){
                GetData()
            }
        }
    })
    return (
        <div>
            <Head title='Socios' />
            {
                stateView===StateView.state1?
                    <Tables />
                :
                    <Form />
            }
        </div>
    );
};

const mapStateToProps = state =>({
    stateView:      state.View.stateView,
    token:          state.Panel.token
})

export default connect(mapStateToProps, {getPartners})(Index);
